module.exports = __webpack_public_path__ + "img/03.86e5c418.png";